import 'date-fns';
import React from 'react'
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import star_icon from '../../assets/images/icons/star-icon.png'





const Index = (props)=>{

    return(
        <div className="dashboard-textfield-container">
          <div className="dashboard-textfield-title">
              <span className="general-span-text">{props.title}</span>
              {props.required && <div>
                  <img src={star_icon}/>
              </div>}
          </div>
          <div className="dashboard-textfield-input">
            <MuiPickersUtilsProvider 
              utils={DateFnsUtils}
              >
              <Grid 
                container 
                justifyContent="space-around"
                style={{width: '94%'}}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label=""
                  format="MM/dd/yyyy"
                  value={props.dateOfBirth}
                  onChange={props.handleDateOfBirth}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  style={{width: '100%'}}
                  error={props.error}
                  helperText={props.helperText}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </div>
        </div>

    )
}

export default Index